import * as Lambda from './LambdaApi';

const listNotifications = async (facilityId) => {
    try {
        const apiPath = `/s2l/${facilityId}/listDeviceNotifications`
        const response = await Lambda.Post(apiPath, {}, 'lambda')
        if (response.success && response.Result.Success) {
            return response.Result.Content.Result
        } else {
            throw Error('Error while fetching all notifications!')
        }
    } catch (error) {
        console.error(error)
        throw Error(error)
    }
}

const sendAlexaDeviceNotification = async (message:string, roomIds:string[], relativeUserId, facilityId) => {
    const apiPath = `/s2l/${facilityId}/sendDeviceNotification`
    const response = await Lambda.Post(apiPath, {
        Message: message,
        RoomIds: roomIds,
        relativeUserId
    }, 'lambda')
    return response
}

const sendAlexaProactiveSuggestion = async (subject: string, message: string, roomIds: string[], endDate: string, relativeUserId, facilityId) => {
    const apiPath = `/s2l/${facilityId}/sendProactiveSuggestion`
    const response = await Lambda.Post(apiPath, {
        Subject: subject,
        Message: message,
        RoomIds: roomIds,
        EndDate: endDate,
        relativeUserId
    }, 'lambda')
    return response
}

export {
    listNotifications,
    sendAlexaDeviceNotification,
    sendAlexaProactiveSuggestion
}
